import companyApi from "../../config/httpClient-company";
import { IOpportunity, IOpportunityFetchResponse, IUserPostulation } from "../constants/app.dto";

export const getOpportunities = async (userId: string): Promise<{ [key: string]: IOpportunity }> => {
  const request = await companyApi.get(`/companies/opportunities/${userId}?status=ACTIVE`);

  return request.data;
}

export const getOpportunity = async (companyId: string, opportunityId: string): Promise<IOpportunityFetchResponse> => {
  const request = await companyApi.get(`/companies/${companyId}/opportunities/${opportunityId}`);

  return request.data;
}

export const getUserPostulation = async (userId: string, companyId: string, opportunityId: string): Promise<IUserPostulation> => {
  const request = await companyApi.get(`/companies/${companyId}/opportunities/${opportunityId}/subscription?customerId=${userId}`);

  return request.data;
}

export const createUserPostulation = async (companyId: string, opportunityId: string, data: any) => {
  const request = await companyApi.post(`/companies/${companyId}/opportunities/${opportunityId}/subscription`, data);

  return request.data;
}
